export default {
  lang: 'lv',
  dir: 'ltr',
  common: {
    ok: 'Glābt',
    cancel: 'Atcelt',
    key_backspace: 'backspace',
    key_del: 'delete',
    key_down: 'down',
    key_up: 'up',
    more_opts: 'More Options',
    url: 'URL',
    width: 'Width',
    height: 'Height'
  },
  misc: {
    powered_by: 'Powered by'
  },
  ui: {
    toggle_stroke_tools: 'Show/hide more stroke tools',
    palette_info: 'Noklikšķiniet, lai mainītu aizpildījuma krāsu, shift-click to mainīt stroke krāsa',
    zoom_level: 'Pārmaiņu mērogu',
    panel_action: 'Click to open side panel',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:',
    panel: 'Panelis'
  },
  properties: {
    id: 'Identify the element',
    fill_color: 'Change aizpildījuma krāsu',
    stroke_color: 'Change stroke krāsa',
    stroke_style: 'Maina stroke domuzīme stils',
    stroke_width: 'Change stroke platums',
    pos_x: 'Change X coordinate',
    pos_y: 'Change Y coordinate',
    linecap_butt: 'Linecap: Butt',
    linecap_round: 'Linecap: Round',
    linecap_square: 'Linecap: Square',
    linejoin_bevel: 'Linejoin: Bevel',
    linejoin_miter: 'Linejoin: Miter',
    linejoin_round: 'Linejoin: Round',
    angle: 'Mainīt griešanās leņķis',
    blur: 'Change gaussian blur value',
    opacity: 'Mainīt izvēlēto objektu necaurredzamība',
    circle_cx: 'Maina aplis&#39;s CX koordinēt',
    circle_cy: 'Pārmaiņu loks ir cy koordinēt',
    circle_r: 'Pārmaiņu loks ir rādiuss',
    ellipse_cx: 'Mainīt elipses&#39;s CX koordinēt',
    ellipse_cy: 'Mainīt elipses&#39;s cy koordinēt',
    ellipse_rx: 'Mainīt elipses&#39;s x rādiuss',
    ellipse_ry: 'Mainīt elipses&#39;s y rādiuss',
    line_x1: 'Mainīt līnijas sākas x koordinēt',
    line_x2: 'Mainīt līnijas beigu x koordinēt',
    line_y1: 'Mainīt līnijas sākas y koordinātu',
    line_y2: 'Mainīt līnijas beigu y koordinātu',
    rect_height: 'Change Taisnstūra augstums',
    rect_width: 'Change taisnstūra platums',
    corner_radius: 'Maina Taisnstūris Corner Rādiuss',
    image_width: 'Mainīt attēla platumu',
    image_height: 'Mainīt attēla augstums',
    image_url: 'Change URL',
    node_x: "Change node's x coordinate",
    node_y: "Change node's y coordinate",
    seg_type: 'Change Segment type',
    straight_segments: 'Straight',
    curve_segments: 'Curve',
    text_contents: 'Mainītu teksta saturs',
    font_family_label: 'Fonts:',
    font_family: 'Mainīt fonta Family',
    font_size: 'Mainīt fonta izmēru',
    bold: 'Bold Text',
    text_decoration_underline: 'Underline',
    text_decoration_linethrough: 'Line-Through',
    text_decoration_overline: 'Overline',
    italic: 'Kursīvs',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    text_letter_spacing: 'Change the letter spacing',
    text_word_spacing: 'Change the word spacing',
    text_length: 'Lets you specify the width of the space into which the text will draw',
    text_length_adjust: 'Length adjust',
    text_length_adjust_spacing: 'Spacing',
    text_length_adjust_spacing_and_glyphs: 'Spacing & Glyphs',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat',
    r_label: 'r',
    x_label: 'x',
    y_label: 'y',
    x1_label: 'x1',
    y1_label: 'y1',
    x2_label: 'x2',
    y2_label: 'y2',
    rx_label: 'rx',
    ry_label: 'ry',
    cx_label: 'cx',
    cy_label: 'cy',
    w_label: 'w',
    h_label: 'h',
    id_label: 'Identifikators',
    class_label: 'klasē',
    label: 'etiķete'
  },
  tools: {
    main_menu: 'Main Menu',
    bkgnd_color_opac: 'Change background color / necaurredzamība',
    connector_no_arrow: 'No arrow',
    fitToContent: 'Fit to Content',
    fit_to_all: 'Fit uz visu saturu',
    fit_to_canvas: 'Ievietot audekls',
    fit_to_layer_content: 'Ievietot slānis saturs',
    fit_to_sel: 'Fit atlases',
    align_relative_to: 'Līdzināt, salīdzinot ar ...',
    relativeTo: 'salīdzinājumā ar:',
    page: 'lapa',
    largest_object: 'lielākais objekts',
    selected_objects: 'ievēlēts objekti',
    smallest_object: 'mazākais objekts',
    export_img: 'Export',
    import_doc: 'Import SVG',
    align_to_page: 'Align Element to Page',
    align_bottom: 'Līdzināt Bottom',
    align_center: 'Līdzināt uz centru',
    align_left: 'Līdzināt pa kreisi',
    align_middle: 'Līdzināt Middle',
    align_right: 'Līdzināt pa labi',
    align_top: 'Līdzināt Top',
    mode_select: 'Select Tool',
    mode_fhpath: 'Pencil Tool',
    mode_line: 'Line Tool',
    mode_rect: 'Rectangle Tool',
    mode_square: 'Square Tool',
    mode_fhrect: 'Free-Hand Taisnstūris',
    mode_ellipse: 'Elipse',
    mode_circle: 'Circle',
    mode_fhellipse: 'Free-Hand Ellipse',
    mode_path: 'Path',
    mode_text: 'Text Tool',
    mode_image: 'Image Tool',
    mode_zoom: 'Zoom Tool',
    no_embed: 'NOTE: This image cannot be embedded. It will depend on this path to be displayed',
    undo: 'Atpogāt',
    redo: 'Redo',
    tool_source: 'Rediģēt Source',
    wireframe_mode: 'Wireframe Mode',
    clone: 'Clone Element(s)',
    del: 'Delete Element(s)',
    group_elements: 'Grupa Elements',
    make_link: 'Make (hyper)link',
    set_link_url: 'Set link URL (leave empty to remove)',
    to_path: 'Convert to Path',
    reorient_path: 'Reorient path',
    ungroup: 'Atgrupēt Elements',
    docprops: 'Document Properties',
    editor_homepage: 'SVG-Edit Home Page',
    move_bottom: 'Pārvietot uz leju',
    move_top: 'Pārvietot uz augšu',
    node_clone: 'Clone Node',
    node_delete: 'Delete Node',
    node_link: 'Link Control Points',
    add_subpath: 'Add sub-path',
    openclose_path: 'Open/close sub-path',
    source_save: 'Glābt',
    cut: 'Cut',
    copy: 'Copy',
    paste: 'Paste',
    paste_in_place: 'Paste in Place',
    delete: 'Dzēst',
    group: 'Group',
    move_front: 'Bring to Front',
    move_up: 'Bring Forward',
    move_down: 'Send Backward',
    move_back: 'Send to Back',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.',
    flip_horizontal: 'Apgriezt horizontāli',
    flip_vertical: 'Apgriezt vertikāli'
  },
  layers: {
    layer: 'Layer',
    layers: 'Layers',
    del: 'Dzēst Layer',
    move_down: 'Pārvietot slāni uz leju',
    new: 'New Layer',
    rename: 'Pārdēvēt Layer',
    move_up: 'Pārvietot slāni uz augšu',
    dupe: 'Duplicate Layer',
    merge_down: 'Merge Down',
    merge_all: 'Merge All',
    move_elems_to: 'Move elements to:',
    move_selected: 'Move selected elements to a different layer'
  },
  config: {
    image_props: 'Image Properties',
    doc_title: 'Title',
    doc_dims: 'Canvas Dimensions',
    included_images: 'Included Images',
    image_opt_embed: 'Embed data (local files)',
    image_opt_ref: 'Use file reference',
    editor_prefs: 'Editor Preferences',
    language: 'Language',
    background: 'Editor Background',
    editor_img_url: 'Image URL',
    editor_bg_note: 'Note: Background will not be saved with image.',
    select_predefined: 'Izvēlieties iepriekš:',
    units_and_rulers: 'Units & Rulers',
    show_rulers: 'Show rulers',
    base_unit: 'Base Unit:',
    grid: 'Grid',
    snapping_onoff: 'Snapping on/off',
    snapping_stepsize: 'Snapping Step-Size:',
    grid_color: 'Grid color',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: 'Invalid value given',
    noContentToFitTo: 'No content to fit to',
    dupeLayerName: 'There is already a layer named that!',
    enterUniqueLayerName: 'Please enter a unique layer name',
    enterNewLayerName: 'Please enter the new layer name',
    layerHasThatName: 'Layer already has that name',
    QmoveElemsToLayer: "Move selected elements to layer '%s'?",
    QwantToClear: 'Do you want to clear the drawing?\n' +
      'This will also erase your undo history!',
    QwantToOpen: 'Do you want to open a new file?\nThis will also erase your undo history!',
    QerrorsRevertToSource: 'There were parsing errors in your SVG source.\n' +
      'Revert back to original SVG source?',
    QignoreSourceChanges: 'Ignore changes made to SVG source?',
    featNotSupported: 'Feature not supported',
    enterNewImgURL: 'Enter the new image URL',
    defsFailOnSave: 'NOTE: Due to a bug in your browser, this image may appear wrong (missing gradients or elements). It will however appear correct once actually saved.',
    loadingImage: 'Loading image, please wait...',
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: 'Also note the following issues: ',
    unsavedChanges: 'There are unsaved changes.',
    enterNewLinkURL: 'Enter the new hyperlink URL',
    errorLoadingSVG: 'Error: Unable to load SVG data',
    URLLoadFail: 'Unable to load from URL',
    retrieving: "Retrieving '%s' ...",
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
}
